var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.152,
    height: 54.479,
    viewBox: "0 0 53.152 54.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_27",
    "data-name": "Intersection 27",
    d: "M32.432,54.479a2.3,2.3,0,0,1-2.3-2.3v-.14H16.559v-1.4h.057l-.033-.026,4.344-5.479H4.1a4.108,4.108,0,0,1-4.1-4.1V9.85a4.108,4.108,0,0,1,4.1-4.1H21.031v1.4H4.1a2.7,2.7,0,0,0-2.7,2.7v27.2H30.132V29.417a2.3,2.3,0,0,1,2.3-2.3H47.346a2.3,2.3,0,0,1,2.3,2.3V37.05h2.1V9.85a2.7,2.7,0,0,0-2.7-2.7H41.327v-1.4h7.721a4.108,4.108,0,0,1,4.1,4.1V41.027a4.106,4.106,0,0,1-3.5,4.054v7.1a2.3,2.3,0,0,1-2.3,2.3Zm-.9-2.3a.9.9,0,0,0,.9.9H47.346a.9.9,0,0,0,.9-.9V50.409H31.534ZM18.353,50.634H30.132v-5.5H22.717ZM31.534,29.417V49.006h16.71V29.417a.9.9,0,0,0-.9-.9H32.432A.9.9,0,0,0,31.534,29.417ZM1.4,41.027a2.7,2.7,0,0,0,2.7,2.7H30.132V38.452H1.4Zm48.245,2.628a2.7,2.7,0,0,0,2.1-2.628V38.452h-2.1ZM39.313,51.744a.816.816,0,1,1,.816.816A.817.817,0,0,1,39.313,51.744ZM22.827,25.365l-.431-.284,2.863-4.967-1.249-1.34c-1.628,1.471-3.844,3.279-4.9,3.279a.556.556,0,0,1-.41-.148c-.75-.75,1.487-3.5,3.2-5.391l-1.472-1.58L15.24,17.927l-.189-.684a6.51,6.51,0,0,1,7.865-8.1A23.061,23.061,0,0,1,35.032.847L35.027.831l.548-.14a22.823,22.823,0,0,1,4.02-.647L40.214,0l-.034.621a22.99,22.99,0,0,1-.605,4.128l-.137.568-.012,0a23.017,23.017,0,0,1-8.413,12.429,6.538,6.538,0,0,1-6.362,8.078A3.285,3.285,0,0,1,22.827,25.365Zm3.5-4.9-2.413,4.187a3.269,3.269,0,0,0,.741.072,5.46,5.46,0,0,0,5.46-5.46,5.492,5.492,0,0,0-.066-.835A22.772,22.772,0,0,1,26.323,20.463ZM24.4,15.475a41.537,41.537,0,0,0-4.283,5.01A41.526,41.526,0,0,0,25.131,16.2c.794-.794,2.079-2.174,1.762-2.49a.182.182,0,0,0-.134-.049C26.291,13.662,25.113,14.764,24.4,15.475Zm3.266-2.539c.956.958.119,2.16-1.763,4.041-.143.143-.545.541-1.09,1.054l1.252,1.344a21.78,21.78,0,0,0,4.012-2.3A21.929,21.929,0,0,0,38.387,4.957a5.524,5.524,0,0,1-3.019-3.066A21.981,21.981,0,0,0,21.227,14.177l1.425,1.53c.472-.5.841-.873.977-1.009,1.348-1.349,2.347-2.161,3.158-2.161A1.216,1.216,0,0,1,27.669,12.936Zm-10.026-1.42a5.47,5.47,0,0,0-1.679,4.727l4.226-2.437a22.838,22.838,0,0,1,2.036-3.695,5.557,5.557,0,0,0-.852-.069A5.44,5.44,0,0,0,17.644,11.516Zm2.925,2.776.008-.009-.018-.007ZM37.559,1.4c-.15.025-.3.057-.448.086-.225.043-.448.093-.671.144a4.444,4.444,0,0,0,2.194,2.249c.048-.229.1-.457.138-.687.028-.155.059-.31.083-.466.078-.508.144-1.018.187-1.531C38.545,1.24,38.05,1.312,37.559,1.4ZM30.645,6.924A2.664,2.664,0,1,1,33.31,9.588,2.668,2.668,0,0,1,30.645,6.924Zm1.1,0A1.568,1.568,0,1,0,33.31,5.356,1.569,1.569,0,0,0,31.742,6.924Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimize);
export default __webpack_public_path__ + "static/media/optimize.e2a8f9771ea561d7b0ee6f9b18c890fa.svg";
export { ForwardRef as ReactComponent };